import React from 'react'
import * as C from './styles'

export default function Loading() {
  return (
    <C.Logo/>
  )
}
